import React, { Component } from 'react';
import browserHistory from '../../history';
import Header from './Header';
import Footer from './Footer';
import Recaptcha from 'react-recaptcha';
import axios from "axios";
class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Title: window.site.config.siteTitle,
            projectinfo: {},
            errors: {},
            contact: true,
            verifyCaptcha: false,

        };
        this.sendmessage = this.sendmessage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.expiredCall = this.expiredCall.bind(this);
    }
    componentDidMount() {
        let self = this
    }
    handleChange(e) {
        let self = this;
         let { projectinfo } = self.state
        console.log("projectinfo ", self.state)
        if (!!this.state.errors[e.target.name]) {
            let errors = Object.assign({}, this.state.errors);
            delete errors[e.target.name];
            this.setState({
                [e.target.name]: e.target.value,
                errors
            });
        } else {
            projectinfo[e.target.name] = e.target.value;
            this.setState({ projectinfo, [e.target.name]: e.target.value });
        }
    }
    validate_onchange_email(method) {
        let formIsValid = true;
        let errors = {};
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(method) == false) {
            formIsValid = false;
            errors.email = "Invalid Email ID";
        }
        this.setState({ errors });
        return formIsValid;
    }
    formValidation() {
        let errors = {};
        let formIsValid = false;
        const eml = this.validate_onchange_email(this.state.email);
        const ceml = this.validate_onchange_email(this.state.confirmEmail);
        if (this.state.name === undefined || this.state.name === '') {
            formIsValid = true;
            errors.name = "Firstname Required";
        }
        if (this.state.email === undefined || this.state.email === '') {
            formIsValid = true;
            errors.email = "Email Required";
        }
        if (this.state.confirmEmail === undefined || this.state.confirmEmail === '') {
            formIsValid = true;
            errors.confirmEmail = "Confirm Email Required";
        }
        if (this.state.supporttype === undefined || this.state.supporttype === '') {
            formIsValid = true;
            errors.supporttype = "Support Type Required";
        }
        if (this.state.message === undefined || this.state.message === '') {
            formIsValid = true;
            errors.message = "Message Required";
        }
        if (this.state.email != this.state.confirmEmail) {
            formIsValid = true;
            errors.confirmEmail = "Invalid Confirmation Email ID";
        }
        this.setState({
            errors
        });
        return formIsValid;
    }
    verifyCallback(response) {
        let self = this;
        if (response) {
            self.setState({ verifyCaptcha: true });
        }
    };

    expiredCall(response) {
        let self = this;
        self.setState({ verifyCaptcha: false });
    };
    sendmessage(e) {
        var self = this;
        let siteSettings = window.site;
        let envoiScreeningApiBaseUrl = siteSettings && siteSettings.screeningApiBaseUrl;
        let appStorage = window.app.storage;
        let token = appStorage.getItem('token');
        // $("#loading").modal('show');
        if (!token && !self.formValidation()) {
            axios.post(envoiScreeningApiBaseUrl + '/contactus?appname=' + window.app.appName + '&env=' + window.app.appEnvName, this.state.projectinfo, { 'Content-Type': 'application/json' })
                .then(function (response) {
                    // $("#loading").modal('hide');
                    if (response && response.data && response.data.statusCode == 200) {

                        browserHistory.push('/success');
                    }
                })
                .catch(function (error) {
                });

        } else {

            this.state.projectinfo["confirmEmail"] = this.state.projectinfo["email"]
            axios.post(envoiScreeningApiBaseUrl + '/contactus?appname=' + window.app.appName + '&token=' + token + '&env=' + window.app.appEnvName, this.state.projectinfo, { 'Content-Type': 'application/json' })
                .then(function (response) {
                    // $("#loading").modal('hide');
                    if (response && response.data && response.data.statusCode == 200) {

                        browserHistory.push('/success');
                    }
                })
                .catch(function (error) {
                });

        }
    }
    render() {
        let self = this;
        const { projectinfo } = self.state;
        let CaptchaKey = (((window.site.config || {}).captcha || {}).google || {}).siteKey;
        const number = (window.site.config || {}).contactNumber || '+1 (310) 337-4737';
        const isScreenixx = window.app && window.app.appName === 'screenixx';

        const S = {
            page:            { minHeight: 'calc(100vh - 180px)', backgroundColor: 'var(--mainbgColor, #15171b)', color: '#ffffff', padding: '60px 20px', fontFamily: 'var(--bodyfont, sans-serif)' },
            container:       { maxWidth: '900px', margin: '0 auto' },
            heading:         { fontSize: '28px', fontWeight: '700', marginBottom: '8px', fontFamily: 'var(--boldfont, sans-serif)' },
            subHeading:      { fontSize: '15px', color: '#aaaaaa', marginBottom: '36px' },
            divider:         { border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', margin: '0 0 36px' },
            grid:            { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '48px' },
            sectionLabel:    { fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', color: 'var(--highlight, #e9c548)', textTransform: 'uppercase', marginBottom: '24px' },
            field:           { display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '18px' },
            label:           { fontSize: '13px', color: '#aaaaaa', fontFamily: 'var(--bodyfont, sans-serif)' },
            input:           { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'var(--bodyfont, sans-serif)' },
            select:          { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', appearance: 'none', boxSizing: 'border-box', cursor: 'pointer', fontFamily: 'var(--bodyfont, sans-serif)' },
            textarea:        { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', resize: 'vertical', minHeight: '130px', boxSizing: 'border-box', fontFamily: 'var(--bodyfont, sans-serif)' },
            error:           { fontSize: '12px', color: '#ff5555', marginTop: '2px' },
            btn:             { padding: '11px 32px', background: 'var(--highlight, #e9c548)', border: 'none', borderRadius: '6px', color: '#15171b', fontWeight: '700', fontSize: '14px', cursor: 'pointer', letterSpacing: '0.5px', fontFamily: 'var(--boldfont, sans-serif)', marginTop: '8px' },
            btnDisabled:     { opacity: 0.5, cursor: 'not-allowed' },
            contactCard:     { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', padding: '24px 28px', marginBottom: '16px' },
            contactCardLabel:{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.2px', color: '#aaaaaa', textTransform: 'uppercase', marginBottom: '10px' },
            contactCardValue:{ fontSize: '16px', fontWeight: '600', color: '#ffffff', fontFamily: 'var(--boldfont, sans-serif)', margin: 0 },
            emailLink:       { fontSize: '16px', fontWeight: '600', color: 'var(--highlight, #e9c548)', textDecoration: 'none', fontFamily: 'var(--bodyfont, sans-serif)' },
        };

        return (
            <div className="info-page">
                <Header />
                <style>{`
                    @media (max-width: 768px) { .cu-grid { grid-template-columns: 1fr !important; } }
                    .cu-input::placeholder { color: rgba(255,255,255,0.3); }
                    .cu-input:focus { border-color: var(--highlight, #e9c548) !important; }
                    .cu-select option { background: #1e222b; color: #ffffff; }
                `}</style>
                <div style={S.page}>
                    <div style={S.container}>
                        <h1 style={S.heading}>Contact Us</h1>
                        <p style={S.subHeading}>Need help or have feedback? We'd love to hear from you.</p>
                        <hr style={S.divider} />

                        <div style={S.grid} className="cu-grid">
                            {/* Left – form */}
                            <div>
                                <p style={S.sectionLabel}>Send Us a Message</p>

                                <div style={S.field}>
                                    <label style={S.label}>Name</label>
                                    <input className="cu-input" style={S.input} type="text" name="name" placeholder="Your name" onChange={this.handleChange} />
                                    {this.state.errors.name && <span style={S.error}>{this.state.errors.name}</span>}
                                </div>

                                <div style={S.field}>
                                    <label style={S.label}>Email</label>
                                    <input className="cu-input" style={S.input} type="email" name="email" placeholder="your@email.com" onChange={this.handleChange} value={projectinfo.email || ''} />
                                    {this.state.errors.email && <span style={S.error}>{this.state.errors.email}</span>}
                                </div>

                                <div style={S.field}>
                                    <label style={S.label}>Confirm Email</label>
                                    <input className="cu-input" style={S.input} type="email" name="confirmEmail" placeholder="Confirm your email" onChange={this.handleChange} value={projectinfo.confirmEmail || ''} />
                                    {this.state.errors.confirmEmail && <span style={S.error}>{this.state.errors.confirmEmail}</span>}
                                </div>

                                <div style={S.field}>
                                    <label style={S.label}>Support Type</label>
                                    <select className="cu-select" style={S.select} name="supporttype" onChange={this.handleChange} value={projectinfo.supporttype || ''}>
                                        <option value="">Select support type</option>
                                        <option value="Technical Support">Technical Support</option>
                                        <option value="Ticket Purchasing">Ticket Purchasing</option>
                                        <option value="Customer Service">Customer Service</option>
                                    </select>
                                    {this.state.errors.supporttype && <span style={S.error}>{this.state.errors.supporttype}</span>}
                                </div>

                                <div style={S.field}>
                                    <label style={S.label}>Message</label>
                                    <textarea className="cu-input" style={S.textarea} name="message" placeholder="Please provide as much detail as possible..." onChange={this.handleChange} value={projectinfo.message || ''} />
                                    {this.state.errors.message && <span style={S.error}>{this.state.errors.message}</span>}
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <Recaptcha sitekey={CaptchaKey} render="explicit" verifyCallback={this.verifyCallback} expiredCallback={this.expiredCall} />
                                </div>

                                <button
                                    style={{ ...S.btn, ...(self.state.verifyCaptcha ? {} : S.btnDisabled) }}
                                    type="submit"
                                    onClick={(e) => this.sendmessage(e)}
                                    disabled={!self.state.verifyCaptcha}
                                >
                                    Send Message
                                </button>
                            </div>

                            {/* Right – contact info */}
                            <div>
                                <p style={S.sectionLabel}>Contact Live Support</p>

                                <div style={S.contactCard}>
                                    <p style={S.contactCardLabel}>Call Us</p>
                                    <p style={S.contactCardValue}>{number}</p>
                                </div>

                                {isScreenixx && (
                                    <div style={S.contactCard}>
                                        <p style={S.contactCardLabel}>Email Us</p>
                                        <a href="mailto:contactus@screenixx.com" style={S.emailLink}>contactus@screenixx.com</a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default About;